export default __webpack_public_path__ + "static/media/img-9.238e8bf2.jpg";